import {
  POST,
  GET
} from '@/axios/axios'
import {FILE} from "../../axios/axios";

export const services = {
  getServiceAllList: () => {  // 获取所有服务商列表
    return GET("/backend/serviceMerchantRel/queryServiceOfBackand");
  },
  setServiceSwitch: (param) =>{  // 设置切换服务商
    return GET("/backend/custom/updateServiceMerchantRel", param)
  },
  configPayList: (param) => { // 支付账户配置列表
    return GET("/backend/config/pay/list", param);
  },
  authServiceList: (param) => { // 支付分流设置列表
    return GET("/backend/custom/shunt/serviceList", param);
  },
  configPayUpdate: (param) => { // 多服务商配置提交
    return POST("/backend/config/pay/update", param);
  },
  shuntSwitch: (param) => { // 服务商/商户修改支付分流开关
    return POST("/backend/customPaymentSetting/shunt/switch", param);
  },
  shuntServiceList: (param) => { // 支付分流服务商列表
    return GET("/backend/customPaymentSetting/shunt/serviceList", param);
  },
  shuntCreate: (param) => { // 服务商/商户支付分流参数新增
    return POST("/backend/customPaymentSetting/shunt/create", param);
  },
  shuntUpdate: (param) => { // 服务商/商户支付分流参数编辑
    return POST("/backend/customPaymentSetting/shunt/update", param);
  },
  shuntPaymentChenk: (param) => { // 服务商/商户支付分流删除/禁用/启用按钮
    return POST("/backend/customPaymentSetting/shunt/paymentChenk", param);
  },
  amountRangeCreate: (param) => { // 商户/服务商支付分流参数金额区间新增
    return POST("/backend/customPaymentSetting/shunt/amountRangeCreate", param);
  },
  amountRangeUpdate: (param) => { // 商户/服务商支付分流参数金额区间编辑
    return POST("/backend/customPaymentSetting/shunt/amountRangeUpdate", param);
  },
  amountPaymentChenk: (param) => { // 商户/服务商支付分流参数金额区间编辑
    return POST("/backend/customPaymentSetting/shunt/amountPaymentChenk", param);
  },
  customServiceList: (param) => { // 服务商余额提醒列表
    return GET("/backend/customPaymentAccountSetting/shunt/serviceList", param);
  },
  customCreate: (param) => { // 余额提醒新增
    return POST("/backend/customPaymentAccountSetting/shunt/create", param);
  },
  customUpdate: (param) => { // 余额提醒编辑
    return POST("/backend/customPaymentAccountSetting/shunt/update", param);
  },
  customRemindChenk: (param) => { // 服务商余额提醒删除/禁用/启用按钮
    return POST("/backend/customPaymentAccountSetting/shunt/remindChenk", param);
  },
  shuntMerchantList: (param) => { // 商户设置列表
    return GET("/backend/custom/shunt/merchantList", param);
  },
  customMerchantList: (param) => { // 商户设置列表
    return GET("/backend/customPaymentSetting/shunt/merchantList", param);
  },
  payCheckChannel: (param) => { // 检验参数
    return POST("/backend/config/pay/checkChannel", param);
  },
  deleteDisEnable: (param) => { // 启用停用删除
    return POST("/backend/config/pay/deleteOrDisEnable", param);
  },
  serviceAccount: (param) => { // 账户配置表单提交
    return POST("/backend/account/addServiceAccount", param);
  },
  putAliSwitch: (param) => { // 修改支付宝开关
    return GET("/backend/custom/shunt/putAliSwitchById", param);
  },
  updatePayment: (param) => { // 更新支付配置信息
    return POST("/backend/config/pay/updateMinShengPaymentInfo", param);
  },
  expandIndirectUploadFile: (param) => { // 进件上传文件
    return FILE("/backend/accountAli/expandIndirectUploadFile", param);
  },
  expandIndirect: (param) => { // 进件
    return POST("/backend/accountAli/expandIndirect", param);
  },
  expandIndirectOrderQuery: (param) => { // 查询进件状态
    return GET("/backend/accountAli/expandIndirectOrderQuery", param);
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/serviceConfig.js